module.exports = __webpack_public_path__ + "img/4.0507d90d.png";